// Simplified Amplify configuration
type AmplifyConfig = {
  API?: {
    REST?: Record<string, any>;
  };
  Storage?: {
    AWSS3?: any;
  };
};

export function createAmplifyConfig(config: any): AmplifyConfig {
  return {
    API: {
      REST: {
        main: {
          endpoint: config.apiEndpoints.main,
          region: config.region,
        },
        ...(config.apiEndpoints.media && {
          media: {
            endpoint: config.apiEndpoints.media,
            region: config.region,
          },
        }),
      },
    },
    Storage: config.storage && {
      AWSS3: {
        bucket: config.storage.bucket,
        region: config.storage.region || config.region,
        customDomain: config.storage.cloudfront?.domain
          ? {
              domainName: config.storage.cloudfront.domain,
              region: config.storage.region || config.region,
            }
          : undefined,
      },
    },
  };
}
